var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-content',{staticClass:"p-all"},[_c('keep-alive',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }